import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";
import Category from "@/pcm/store/models/Category";

export default class Tag extends Model {
    static entity = 'tags';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'name',
    };

    static fields() {
        return {
            id: this.uid(),
            name: this.string(''),
            should_display_on_homepage: this.boolean(null),

            categories: this.attr([]),

            created_at: this.string(''),
            updated_at: this.string(''),
        }
    }

    declare id: number;
    declare name: string;
    declare should_display_on_homepage: boolean;

    declare categories: Array<Category>;

}
